/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuPriceRanges_user$ref: FragmentReference;
export type SbSharedRefineMenuPriceRanges_user = {|
  +isVerifiedTrade: ?boolean,
  +$refType: SbSharedRefineMenuPriceRanges_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuPriceRanges_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5f28254e4fdc4994adaee2f3f6380047';
module.exports = node;
